import { Flex } from "@/atoms"
import { Heading } from "@/molecules/Heading"

import styles from "./Tooltip.module.scss"

import type { ColumnTooltipProps } from "./Tooltip.types"

export const ColumnTooltip = (props: ColumnTooltipProps) => {
  const { items, title, width = 160 } = props

  return (
    <Flex
      vertical
      gap={12}
      style={{ minWidth: width }}
      className={styles.columnTooltip}
    >
      <Heading level={6} title={title} />
      {items.map(({ label, value, color }) => (
        <Flex key={label} justify="space-between">
          <Flex gap={8} align="center">
            <span
              style={{ backgroundColor: color }}
              className={styles.columnTooltipMarker}
            />
            {label}
          </Flex>
          {value}
        </Flex>
      ))}
    </Flex>
  )
}
